import http from "./http-common";

class Api {
  //send contact us mail
  sendMail(data) {
    return http.post("/send-mail", data);
  }
  //send quote mail
  sendQuote(data) {
    return http.post("/send-quote", data);
  }
  //send dataset maintance mail
  sendDataset(data) {
    return http.post("/send-dataset", data);
  }
  subscribe(data) {
    return http.post("/subscribe", data);
  }
}

export default new Api();
